"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageFlow = void 0;
const index_1 = require("../Base/index");
/**
 * Contains a BPMN MessageFlow.
 * These are used to showcase the communication between FlowNodes from different processes.
 *
 * For example: "SendTask 1" from Process A sends a message to "ReceiveTask 1" on Process B.
 */
class MessageFlow extends index_1.BaseElement {
}
exports.MessageFlow = MessageFlow;
//# sourceMappingURL=MessageFlow.js.map